/**
 * The page's one call, kept out of the component.
 *
 * CLAUDE.md: components and hooks call the app's API layer, never axios directly. The URL, the parameter
 * and the response shape live here, and the page renders.
 */
import axios from 'axios'
import type { BoxTruckOfferAnalytics, BoxTruckOfferSource } from '@numeo/types-main-mobile'
import { apiErrorMessage } from '@/api/errorMessage'

/** One of `OFFER_ANALYTICS_WINDOW_DAYS`, which the server validates against the same constant; `source` null is both surfaces. */
export async function fetchBoxTruckOfferAnalytics(days: number, source: BoxTruckOfferSource | null, signal?: AbortSignal): Promise<BoxTruckOfferAnalytics> {
    try {
        const res = await axios.get<{ success: boolean; data: BoxTruckOfferAnalytics }>('/gluon/box-truck-offer-analytics', {
            params: { days, ...(source ? { source } : {}) },
            signal,
        })
        return res.data.data
    } catch (error) {
        throw new Error(apiErrorMessage(error))
    }
}
